import { useEffect } from 'react';

export default function useAutoSelectFirst(items, selectedId, onSelect) {
  useEffect(() => {
    if (!selectedId && items?.length) onSelect(items[0].id);
  }, [items, selectedId, onSelect]);
}
